
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"52","height":"52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40.105 52H11.892C5.325 52 0 46.675 0 40.107V11.896C0 5.325 5.325 0 11.892 0h28.213C46.673 0 52 5.325 52 11.896v28.211C52 46.675 46.672 52 40.105 52","fill":"#65E9FB"}}),_c('path',{attrs:{"d":"M20.041 26.752c.928-.444 1.863-.92 2.824-1.343a3.965 3.965 0 012.556-.296 2.273 2.273 0 011.81 2.026c.024.197.032.41.049.591.054.686.38 1.007 1.055.867a5.818 5.818 0 001.55-.608c1.678-.904 3.298-1.952 5.013-2.749 2.473-1.142 5.05-1.335 7.622-.222a5.906 5.906 0 012.787 2.416 1.128 1.128 0 010 1.262.964.964 0 01-1.018.464 1.345 1.345 0 01-.788-.41c-1.45-2.117-3.537-2.43-5.829-2.023-2.032.362-3.747 1.48-5.49 2.515-.91.557-1.86 1.047-2.84 1.467a3.226 3.226 0 01-2.73-.21 2.78 2.78 0 01-1.579-2.592c0-.645-.132-.768-.738-.559-.815.304-1.614.648-2.395 1.031-.264.134-.521.28-.77.44a6.03 6.03 0 00-2.973 3.353c-.746 2.112-2.024 3.978-3.43 5.753-.746.941-1.648.85-2.213-.222a3.39 3.39 0 01.041-2.958 13.463 13.463 0 012.473-3.662c.54-.62 1.15-1.179 1.72-1.77.14-.135.252-.297.325-.477a23.691 23.691 0 00.969-11.17 5.35 5.35 0 00-.483-1.49c-.412-.876-1.129-1.18-1.999-.749a8.87 8.87 0 00-2.197 1.475c-3.69 3.477-5.157 7.722-4.366 12.723.1.649-.057 1.121-.502 1.38a1.091 1.091 0 01-1.287-.115 1.61 1.61 0 01-.412-.756c-1.237-5.917 1.492-12.68 6.468-16.063 1.076-.731 2.234-1.233 3.57-1.023 1.785.304 2.692 1.566 3.17 3.164.618 2.055.639 4.216.503 6.353-.09 1.405-.31 2.802-.466 4.187z","fill":"#000"}})])
          )
        }
      }
    